import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
} from "@mui/material";
import {
  StyledTableRowTemplate,
  StyledTableCellValueTemplate,
  StyledTableCellLabelTemplate,
  LabelTemplate,
  StyledTableContainer,
} from "../../styles/table";
import { Employee } from "../../../types/processTypes";
import { tt } from "../../../../../data/langUtility";

interface Props {
  currentEmployee: Employee;
  template: LabelTemplate;
}
export const BasicFullName = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead></TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("fullName", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {currentEmployee.givenName + " " + currentEmployee.surName}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fullName", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicFullNameGolden = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead></TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellLabelTemplate
                template={{ ...template, bodyHeight: 52 }}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("fullName", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellLabelTemplate
                template={{ ...template, bodyHeight: 48 }}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("fullName", "ar")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={{ ...template, bodyHeight: 48 }}
                sx={{ width: "70%", textAlign: "center" }}
              >
                {currentEmployee.givenName + " " + currentEmployee.surName}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
export const BasicFullNameHeader = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                }}
              >
                {tt("name", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate template={template}>
                {currentEmployee.givenName + " " + currentEmployee.surName}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                }}
              >
                {tt("name", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableHead>
          <TableBody></TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicFullNameEnglish = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead></TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "25%",
                }}
              >
                {tt("fullName", "en")}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "50%",
                }}
              >
                {currentEmployee.givenName + " " + currentEmployee.surName}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "25%",
                }}
              >
                {currentEmployee.address?.telephone}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicNameOnly = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead></TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  textAlign: "center",
                }}
              >
                {currentEmployee.givenName + " " + currentEmployee.surName}
              </StyledTableCellValueTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};

export const BasicContactNumber = ({ currentEmployee, template }: Props) => {
  return (
    <>
      <StyledTableContainer template={template}>
        <Table size="small" aria-label="simple table">
          <TableHead></TableHead>
          <TableBody>
            <StyledTableRowTemplate template={template} key="4">
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "left",
                  width: "25%",
                }}
              >
                {"Contact Number"}
              </StyledTableCellLabelTemplate>
              <StyledTableCellValueTemplate
                template={template}
                sx={{
                  width: "50%",
                  textAlign: "center",
                }}
              >
                {currentEmployee.address?.telephone}
              </StyledTableCellValueTemplate>
              <StyledTableCellLabelTemplate
                template={template}
                sx={{
                  textAlign: "right",
                  width: "25%",
                }}
              >
                {tt("telephone", "ar")}
              </StyledTableCellLabelTemplate>
            </StyledTableRowTemplate>
          </TableBody>
        </Table>
      </StyledTableContainer>
    </>
  );
};
